import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getRequestErrorMessage } from '@/utils/requestError';

// 私有列表切换账号、筛选或页面后，不接受上一轮请求的结果。
const usePrivateList = (fetchList, params = {}, fallback = '列表加载失败，请重试') => {
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  const sessionKey = `${sessionVersion}:${userInfo?.id}`;
  const query = JSON.stringify(params);
  const key = `${sessionKey}:${query}`;
  const [state, setState] = useState({ key: null, source: null, data: null, loading: true, error: '' });
  const version = useRef(0);
  const load = useCallback(async () => {
    if (!isAuthenticated) return;
    const current = ++version.current;
    setState(previous => ({ key, source: fetchList, data: previous.key === key && previous.source === fetchList ? previous.data : null, loading: true, error: '' }));
    try {
      const data = await fetchList(JSON.parse(query));
      if (version.current === current) setState({ key, source: fetchList, data, loading: false, error: '' });
      return data;
    } catch (error) {
      const text = typeof fallback === 'function' ? fallback(error) : getRequestErrorMessage(error, fallback);
      if (version.current === current) setState(previous => ({ key, source: fetchList,
        data: [401, 403, 404, 405].includes(error.response?.status) || previous.key !== key || previous.source !== fetchList ? null : previous.data,
        loading: false, error: text }));
      throw new Error(text);
    }
  }, [fetchList, query, key, isAuthenticated, fallback]);
  useEffect(() => {
    void load().catch(() => {});
    return () => { version.current += 1; };
  }, [load]);
  return { ...(state.key === key && state.source === fetchList ? state : { data: null, loading: true, error: '' }), load, sessionKey, isAuthenticated };
};
export default usePrivateList;
